<template>
  <div>
    <b-media tag="li">
      <template v-if="getOrganizationBanner" v-slot:aside>
          <b-card-img style="object-fit: initial; height: 64px; width: 64px" :src="getOrganizationBanner"></b-card-img>
      </template>
      <template v-else v-slot:aside>
        <span class="bg-gray pt-3" id="media-wrapper">
          <font-awesome-icon style="color: grey" class="align-middle" icon="landmark" size="2x"/>
        </span>
      </template>
      <h5 class="mt-0  mb-3 text-left">
        <b-link
          class="text-blue"
          :to="{ name: 'organizationView', params: { id: organization.id }}"
          target="_blank"
          title="View"
          v-b-tooltip.hover.right>
          {{ getTitle }}
        </b-link>
      </h5>
      <p class="mb-0 text-left">
        <b-row>
          <b-col cols="6" lg="12" md="12" sm="12" xs="12">
            <span class="mr-lg-2" title="Creation date" v-b-tooltip.hover.bottom>
              <font-awesome-icon icon="calendar-alt"/> {{ organization.created | utcLocalDate }}
            </span>
            <span v-if="organization.country" title="The country where the organization is hosted" v-b-tooltip.hover.bottom>
              <font-awesome-icon icon="map-marker-alt"/> {{ organization.country }}
            </span>
            <span v-if="organization.rights === 'OWN'">
              <router-link :to="{ name: 'organizationEdit', params: { id: organization.id } }">
                <b-button
                v-b-tooltip.hover.bottom
                title="Edit"
                class="btn-dark btn-sm"
                @click="editOrganisation(organization.id)"
                target="_blank">
                  <font-awesome-icon icon="pen" size="lg"/>
              </b-button>
              </router-link>
            </span>
            <span v-if="organization.rights === 'OWN'">
              <b-button
                v-b-tooltip.hover.bottom
                title="Delete"
                class="btn-danger btn-sm"
                @click="showMsgDelete(organization.id, organization.name)"
                target="_blank">
                  <font-awesome-icon icon="trash-alt" size="lg"/>
              </b-button>
            </span>
            <span class="float-right align-top" >
              <b-button
                v-if="organization.url && organization.url !== ''"
                class="btn bg-orange btn-sm"
                :href="getOrganizationExternalLink"
                target="_blank">
                Visit website <font-awesome-icon icon="angle-right" size="lg"/>
              </b-button>
            </span>
          </b-col>
        </b-row>
      </p>
    </b-media>
    <hr>
  </div>
</template>

<script>

export default {
  name: 'OrganizationMedia',
  props: {
    'organization': Object
  },
  computed: {
    isOwner: function () {
      if (this.type === 'OWN') {
        return true
      } else if (this.type === 'PUBLIC') {
        return false
      } else if (this.type === 'SHARE') {
        return false
      } else {
        return false
      }
    },
    getTitle () {
      let title = this.organization.name
      if (title) {
        return title
      }
      return '<Untitled>'
    },
    getOrganizationExternalLink () {
      let link = this.organization.url
      if (link !== undefined && link.startsWith('https')) {
        return link
      }
      if (link !== undefined && link.startsWith('www')) {
        return '//' + link
      }
      if (link !== undefined && link.startsWith('http')) {
        return link
      }
      return ''
    },
    getOrganizationBanner () {
      let image = this.organization.bannerUrl
      return image
    }
  },
  methods: {
    showMsgDelete (orgId, orgTitle) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this organisation.', {
        title: 'Are you sure you want to delete ' + orgTitle + '?',
        size: 'bg',
        buttonSize: 'bg',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.deleteOrganization(orgId)
          } else {}
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    deleteOrganization (orgId) {
      this.$store.dispatch('deleteOrganizationEntity', orgId).then(
        data => {
          window.location.reload()
        })
    },
    editOrganisation (orgId) {
      this.$store.push({ name: 'organizationEdit', params: { id: orgId } })
    }
  }

}
</script>

<style scoped>
#media-wrapper {
  width: 64px;
  height: 64px
}
</style>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationMedia.vue